import { render, staticRenderFns } from "./viewEvaluation.vue?vue&type=template&id=ef66c878&scoped=true&"
import script from "./viewEvaluation.vue?vue&type=script&lang=js&"
export * from "./viewEvaluation.vue?vue&type=script&lang=js&"
import style0 from "./viewEvaluation.vue?vue&type=style&index=0&id=ef66c878&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef66c878",
  null
  
)

export default component.exports